import { Component, Input } from '@angular/core';
import { Agenda } from '../../models/agenda.model';

/**
 * Generated class for the AgendaComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'agenda',
  templateUrl: 'agenda.html'
})
export class AgendaComponent {

  @Input() data: Agenda[];

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/agenda/agenda.ts